import { createErrorClass } from './createErrorClass';
export var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + ' errors occurred during unsubscription:\n' + errors.map(function (err, i) {
            return i + 1 + ') ' + err.toString();
        }).join('') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});